<div class="modal-wrapper">
  <form [formGroup]="addPensionpot" autocomplete="off" role="form" class="fieldHeight">
    <div class="modal" role="dialog" id="modal-dialog" aria-labelledby="dialog-label" aria-modal="true" tabindex="-1">
      <div class="modal-header">
        <h4 class="text-md" id="dialog-label">Add your Pension pot</h4>
        <button type="button"><span class="icon icon-cross" aria-hidden="true"></span><span class="access">Close
            modal</span></button>
      </div>
      <div class="modal-content">
        <div class="code-input"></div>
        <button class="btn btn-primary btn-block" type="button">Click here to take survey</button>
        <button class="btn btn-secondary btn-block" type="button">No thanks</button>
      </div>
    </div>
  </form>
</div>